export default __webpack_public_path__ + "static/media/train.4e0bdb3c.png";